import {useContext} from "react";
import {VisuallyHidden} from "@mantine/core";
import {RadioContext} from "./RadioGroup";
import classes from "./form-elements.module.css";

interface RadioProps {
    name: string;
    value: string;
}

export const Radio = ({name, value}: RadioProps) => {
    const {selectedOption, toggle} = useContext(RadioContext);
    const checked = selectedOption === value;

    return (
        <li className={classes.radio}>
            <label className={classes.radioLabel} onClick={() => toggle(value)}>
                <svg
                    className={classes.radioSvg}
                    viewBox="0 0 10 10"
                    aria-hidden="true"
                >
                    <circle
                        cx={5}
                        cy={5}
                        r={4}
                        className={`${classes.radioCircleBorder}${checked ? ` ${classes.checked}` : ""}`}
                    />
                    <circle
                        cx={5}
                        cy={5}
                        r={2}
                        className={`${classes.radioCircleFill}${checked ? ` ${classes.checked}` : ""}`}
                    />
                </svg>
                <span className={classes.radioName}>{name}</span>
                <VisuallyHidden>
                    <input
                        type="radio"
                        value={value}
                        checked={checked}
                        tabIndex={-1}
                        onChange={() => toggle(value)}
                    />
                </VisuallyHidden>
            </label>
        </li>
    );
};
